import { SelectItem } from 'primeng/api';

export enum TaskType {
  Proofreading = 'Proofreading',
  Translation = 'Translation',
  DesktopPublishing = 'Desktop Publishing',
  QualityAssurance = 'Quality Assurance',
  QAReview = 'QA Review',
  DirectFiling = 'Direct Filing',
  EPFiling = 'EP Filing',
  PCTFiling = 'PCT Filing',
  UnitaryPatentFiling = 'Unitary Patent Filing',
  FilingConfirmation = 'Filing Confirmation',
  FADocumentReceipt = 'FA Document Receipt',
  FADocumentManagement = 'FA Document Management',
  EstimateReview = 'Estimate Review',
  CompleteProject = 'Complete Project',
  DocumentExecution = 'Document Execution',
  TranslationDelivery = 'Translation Delivery',
  FilingDelivery = 'Filing Delivery',
  FilingReceipt = 'Filing Receipt',
  SendDocumentToClient = 'Send Document To Client',
  SendInvoice = 'Send Invoice',
  SendClientDeliverySchedule = 'Send Client Delivery Schedule',
  SendFADeliverySchedule = 'Send FA Delivery Schedule',
  TranslationsFiled = 'Translations Filed',
  Feedback = 'Feedback',
  TranslationReview = 'Translation Approval',
  SubmitTargetTMFile = 'Submit Target TM File',
  DownloadTargetTMFile = 'Download Target TM File',
  TranslationCertification = 'Translation Certification',
  Apostille = 'Apostille',
  CertifiedTranslation = 'Certified Translation',
  Notarization = 'Notarization',
  VerifyOfficialFees = 'Verify Official Fees',
  ApproveOfficialFees = 'Approve Official Fee Updates',
  ReviewFilingReport = 'Review Filing Report',
  Other = 'Other',
}

export const TASK_TYPES: SelectItem[] = [
  { label: 'Proofreading', value: TaskType.Proofreading },
  { label: 'Translation', value: TaskType.Translation },
  { label: 'Desktop Publishing', value: TaskType.DesktopPublishing },
  { label: 'Quality Assurance', value: TaskType.QualityAssurance },
  { label: 'QA Review', value: TaskType.QAReview },
  { label: 'Direct Filing', value: TaskType.DirectFiling },
  { label: 'EP Filing', value: TaskType.EPFiling },
  { label: 'PCT Filing', value: TaskType.PCTFiling },
  { label: 'Filing Confirmation', value: TaskType.FilingConfirmation },
  { label: 'FA Document Receipt', value: TaskType.FADocumentReceipt },
  { label: 'FA Document Management', value: TaskType.FADocumentManagement },
  { label: 'Estimate Review', value: TaskType.EstimateReview },
  { label: 'Send Invoice', value: TaskType.SendInvoice },
  { label: 'Complete Project', value: TaskType.CompleteProject },
  { label: 'Document Execution', value: TaskType.DocumentExecution },
  { label: 'Translation Delivery', value: TaskType.TranslationDelivery },
  { label: 'Filing Delivery', value: TaskType.FilingDelivery },
  { label: 'Filing Receipt', value: TaskType.FilingReceipt },
  { label: 'Send Document To Client', value: TaskType.SendDocumentToClient },
  { label: 'Translations Filed', value: TaskType.TranslationsFiled },
  { label: 'Translation Approval', value: TaskType.TranslationReview },
  { label: 'Translation Certification', value: TaskType.TranslationCertification },
  { label: 'Apostille', value: TaskType.Apostille },
  { label: 'Certified Translation', value: TaskType.CertifiedTranslation },
  { label: 'Notarization', value: TaskType.Notarization },
  { label: 'Verify Official Fees', value: TaskType.VerifyOfficialFees },
  { label: 'Approve Official Fee Updates', value: TaskType.ApproveOfficialFees },
  { label: 'Other', value: TaskType.Other },
];
